@import '../../scss/utility';

wb-tabs {
  display: block;
}
